import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getPlatformAdminStatus } from "@/modules/admin/services/adminPlatformService";

type AdminGuardProps = {
  children: React.ReactNode;
};

type AdminGuardStatus = "loading" | "allowed" | "denied" | "error";

export const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<AdminGuardStatus>("loading");

  useEffect(() => {
    let isMounted = true;

    const verifyAccess = async () => {
      try {
        const allowed = await getPlatformAdminStatus();

        if (!isMounted) {
          return;
        }

        setStatus(allowed ? "allowed" : "denied");
      } catch {
        if (!isMounted) {
          return;
        }

        setStatus("error");
      }
    };

    void verifyAccess();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (status === "denied") {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate, status]);

  if (status === "loading") {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-6 text-sm text-muted-foreground">
        Verificando acesso...
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="flex min-h-[40vh] items-center justify-center px-6 text-sm text-muted-foreground">
        Nao foi possivel verificar o acesso administrativo.
      </div>
    );
  }

  if (status === "denied") {
    return null;
  }

  return <>{children}</>;
};
